import {isEmpty} from 'lodash';
import {Injectable} from '@angular/core';
import {UserInteractor} from '../../interactors/user.interactor';
import {LoanApplicationFlowStep} from './loan-application-flow.step';
import {LoanApplicationInteractor} from '../../interactors/loan-application.interactor';

@Injectable()
export class PhoneVerificationStep extends LoanApplicationFlowStep {
    private readonly userInteractor: UserInteractor;
    private readonly applicationInteractor: LoanApplicationInteractor;

    constructor(applicationInteractor: LoanApplicationInteractor, userInteractor: UserInteractor) {
        super();
        this.applicationInteractor = applicationInteractor;
        this.userInteractor = userInteractor;
    }

    async isComplete(): Promise<boolean> {
        const isUserCreated = !!await this.userInteractor.getUserId();
        const application = await this.applicationInteractor.get();
        const isApplicationCreatedOnTheServer = !isEmpty(application) && !!application.id;
        return isUserCreated && isApplicationCreatedOnTheServer;
    }

    url(): string {
        return this.createBorrowerFlowUrl('phone-verification');
    }

    description(): string {
        return 'To help us reach you';
    }

    displayName(): string {
        return 'Mobile verification';
    }
}